import React, { useEffect, useRef, useState } from 'react';
import { makeStyles } from '@material-ui/styles';

import TopAppBar from './TopAppBar';
import WarnningBox from './WarnningBox';
import PanelButtons from './PanelButtons';
import { getStringPaymentOnly,getStringPayment} from '../hooks/orders-format'; 
import PaymentMethod from './PaymentMethod';
import PaymentDialog from './PaymentDialog';

const useStyles = makeStyles((theme) => ({

  containerPage:{
    width: "100vw", 
    //height: "auto",
  },


  containerFlex:{
    width: "100%",
    marginTop: theme.spacing(1),
    display: 'flex', 
    justifyContent: 'center', 
    alignItems: 'center',
   //backgroundColor: "red",
  },

  containerInfo:{
    display: 'flex', 
    flexDirection: 'column', 
    justifyContent: 'center', 
    alignItems: 'center',
    //backgroundColor: 'blue',
    width: "100%",
    //padding: theme.spacing(1),
    paddingBottom: theme.spacing(3),
    marginTop: "5vh", //before 10v
    fontSize: "1.3rem",
    textAlign: "center", 
    [theme.breakpoints.up('md')]: {
      width: "40%",
      padding:  theme.spacing(1),
    },
  },

  image:{
    width:"150px",
  }, 

  containerMethods:{
    width: "100%",
    //backgroundColor: 'yellow', 
    paddingLeft: theme.spacing(2), 
    paddingRight: theme.spacing(2)
  },

  containerOnlyMethod:{
    width: "100%",
    //backgroundColor: 'yellow', 
    paddingLeft: theme.spacing(2), 
    paddingRight: theme.spacing(2)
  }

}));

const getDefaultSelected = (list)=>{
  let newSelected = undefined;   
  if(list.length===1){
      newSelected = {...list[0],checked:true}
   }
   return newSelected; 
}


const urlImage = "https://res.cloudinary.com/wikimenu/image/upload/v1625305097/store-app/payment_options_retzss.png"; 



export default function PaymentPage(props) {
  const classes = useStyles();
  const {store, order, strings, onBack, onNext} = props; 

  

 const [open, setOpen] = useState(false);
 const payChange = useRef(null); 
 const defaultMethods = store.payMethods ? store.payMethods: [];              

 const [methodList,setMethodList]=useState(defaultMethods)
 const [selected, setSelected] =useState(getDefaultSelected(methodList));

  useEffect(async () => {
    if(methodList.length==1)
       return; //just one options  

    const orderPayMethod = order.payMethod; 
    //console.debug("Paymentpage orderPayMethod:",orderPayMethod);
    if(orderPayMethod && orderPayMethod.id){
      const newSelected = {...orderPayMethod,checked:true}
      //console.debug("getDefaultSelected by order:",newSelected);
      handleOnChange(newSelected); 
    }


  }, []);


 
  const handleOnChange = (value) => {
   // console.debug("Paymentpage handleOnChange:",value);
    const newList = [...methodList].map(it=>{
      if(it.id === value.id){
         return {...it, checked:value.checked}
      }else return {...it, checked:false}
    })
    
    setMethodList(newList);
    const newSelected = newList.find(it=>it.checked===true);
    setSelected(newSelected);
  };

  const handlerBack = ()=>{
      onBack(); 
  }

  const handlerNext = ()=>{
    //console.debug("handlerNext:",selected);
    if(order.type=='takeaway'){
        goNext();
        return;  
    }

    
    if(selected.paymentInfo?.cashChange===true){
      setOpen(true); 
      return;
    }

    goNext();
  }

  const handleCloseDialog= ()=>{
    setOpen(false);
  }
  const handleContinueDialog= ()=>{
    handleAcceptDialog(0); 
  }

  const handleAcceptDialog= (value)=>{
    payChange.current=value; 
    goNext(); 
    setOpen(false);
  }

  const goNext=()=>{
    const newOrder = {
      ... order,
    };
    //old scool
 
    newOrder.payMethod={
      id:selected.id,
    }

    if(selected.id.toUpperCase() =='CASH'){
      newOrder.payMethod.change =payChange.current;  
    }
    
   // console.debug("goNext:",newOrder.payMethod);
    onNext(newOrder); 
  }


const getStringPaymentOnly = (method)=>{
  const displayName = method.name; 
  return strings.message_payment_only.replace("${method}",displayName.toUpperCase())
 }

  return (
    <div className = {classes.containerPage}>  
        <TopAppBar title = {strings.title_payment_options} />
        <PaymentDialog 
          open={open}
          onClose ={handleCloseDialog}
          onAccept = {handleAcceptDialog}
          onContinue = {handleContinueDialog}
          title= {strings.paymethod_cash_change_label}
          total={order.totalPrice}
          currency={store.currency}
          labelTotal={strings.total}
          labelChange={strings. paymethod_cash_change_for}
          labelContinue={strings.paymethod_cash_no_change}
          labelAccept={strings.action_done}
          />
       <div className = {classes.containerFlex}>      
        <div className = {classes.containerInfo}>
            <img className ={classes.image} src={urlImage} alt={strings.title_payment_options}  />
          
            {methodList.length==1  && 
            <div className = {classes.containerOnlyMethod}>
            <WarnningBox  
                message={getStringPaymentOnly(methodList[0])}    
                icon={false}   
            />
            </div>
            }

            {methodList.length>1  && 
            <div  className = {classes.containerMethods}>
               <WarnningBox
                message={strings.message_payment_select}    
                icon={false}   
              />
              <div>
                {
                methodList.map((element,index) =>
                    <PaymentMethod
                      key={index+1}
                      method={ element}
                      onChange={handleOnChange}
                      strings={strings}    
                    />
                  )
                }            
              </div>
            </div>
            }          
        </div>             
        <PanelButtons                    
                        labelCancel={strings.action_back}
                        labelNext={strings.action_next}
                        onClickCancel={handlerBack}
                        onClickNext={handlerNext}
                        nextDisabled={!selected && methodList.length!=1 }
                        />   
        </div>
        

       
    </div>
  );
}
